module.exports = __webpack_public_path__ + "static/media/house_stark.bb0369a7.png";